// extracted by mini-css-extract-plugin
module.exports = {"content":"PartnersCyWhy_content__dvNZt"};